// Utilidades de sesion compartidas por axios y RequireAuth.
// El token JWT dura 24h (otc.app.jwtExpirationMs=86400000 en el backend).
export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

export const isTokenExpired = (token) => {
  if (!token) return true;
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return true;
  return payload.exp * 1000 < Date.now();
};

export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    return null;
  }
};

export const clearSession = () => {
  localStorage.removeItem("user");
  localStorage.removeItem("observacionesConductor");
};
